import localesPt from '@/shared/i18n/AuthB2C/pt';
import { REGISTER_PAGE_KEY } from '@/views/Register/constants';

const pt = {
  [REGISTER_PAGE_KEY]: {
    ...localesPt,
    SEO_TITLE: 'Cadastre-se',
    SEO_DESCRIPTION: 'Seja parte da nova geração de profissionais digitais.',

    YOU_HAVE_ACCOUNT: 'Você já tem uma conta?',
    JOIN_CREHANA: 'Matricule-se hoje na Crehana',
    REGISTER_TO_CREHANA: 'Cadastre-se com seu número de telefone',
    REGISTER: 'Cadastre-se',
    OR_ALSO: 'Ou também',
    DO_YOU_HAVE_A_ACCOUNT: 'Você já tem uma conta?',
    LIVE_EXPERIENCE_CREHANA:
      'Viva a melhor experiência de aprendizagem criativa e digital.',
    AUTH_VALIDATION_LEGALS_REQUIRED:
      'Você deve aceitar os Termos, Condições e Políticas para se registrar.',
    LEGALS_TEXT_1: 'Aceito os ',
    LEGALS_TEXT_2: 'Termos, Condições e Políticas de Crehana.',
    LOGIN_GOOGLE_LABEL: 'Continue com google',
    LOGIN_FACEBOOK_LABEL: 'Continue com facebook',
    SOCIAL_BUTTON_TEXT: 'Regístrate con',
    SOCIAL_BUTTON_TEXT_LOGIN: 'Cadastre-se con ',
    CAMPAIGN_AUTH_TITLE:
      'Resgate seu pacote de 10 cursos online aqui, graças à HP.',
    CAMPAIGN_AUTH_SUBTITLE: 'Antes de começar, inscreva-se ou faça login.',
    PHONE: 'Telefone',

    // validations
    INPUT_REQUIRED: 'Campo obrigatório',
    VALIDATE_MAX_PASSWORD: 'Sua senha deve ter no máximo 6 caracteres',
    VALIDATE_MIN_PASSWORD: 'Sua senha deve ter pelo menos 6 caracteres',
    VALIDATE_FORMAT_EMAIL: 'Por favor digite um email válido.',
    PASSWORD_DOES_NOT_MATCH: 'As senhas não correspondem',

    SIGN_IN: 'Entrar',
    EMAIL: 'E-mail',
    PASSWORD: 'Senha',

    CHECKBOX_DATA_USAGE:
      'Autorizo ​​a Crehana a usar os dados fornecidos para entrar em contato comigo e receber promoções, ofertas e informações de produtos novos.',
  },
};

export default pt;
